import { HTTP } from '@/axios_api/http-common' 

const state = {
  files: []
}

interface IState {
    files: Array<IFile>
}

interface IFile {
    id: number,
    fileName: string,
    fileDescription: string,
    projectId: string,
    associatedModel: string,
    associatedOperationUnitId: string,
    associatedDepartmentId: string,
    meta:string
}

const mutations = {
    setFiles (state: IState, files: Array<IFile>) {
        state.files = files
    },
    addFile(state: IState, file: IFile){
        state.files.push(file)
    },
    deleteFile(state: IState, fileId: any){
        const fileToDeleteIndex = state.files.findIndex(f => f.id == fileId)
        if(fileToDeleteIndex>-1){
            state.files.splice(fileToDeleteIndex,1)
        }
    }
}
const getters = {
    filteredFiles : (state:IState) => (projectId:string="",departmentId:string="",operationUnitId:string="",associatedModel:string="",meta:string="") => {
        return state.files.filter(f => 
            (f.associatedModel == associatedModel||associatedModel==null||associatedModel=="")&&
            (f.associatedDepartmentId == departmentId||departmentId==null||departmentId=="")&&
            (f.associatedOperationUnitId == operationUnitId||operationUnitId==null||operationUnitId=="")&&
            (f.projectId == projectId||projectId==null||projectId=="")&&
            (f.meta == meta||meta==null||meta=="")
        )
    }
}
const actions = {
    getFiles ({ commit } : { commit: any}) {       
        return new Promise((resolve, reject) => {
            HTTP.get('files')
            .then((response: any) => {
                commit('setFiles', response.data.data)         
                resolve(response)                    
            })
            .catch((error: any) => {
                reject(error)
            })
        })
    },
    uploadFile ({ commit } : { commit: any }, fileData: any) {
        return new Promise((resolve, reject) => {
            HTTP.post('files/upload', fileData)
            .then((response: any) => {
                commit('addFile',response.data.data) 
                resolve(response)
            })
            .catch((error: any) => {
              reject(error)
            })
        })
    },
    downloadFile({commit} : {commit : any}, fileData: any){
        return new Promise((resolve,reject) => {
            HTTP.get('files/download/'+fileData.fileId,{responseType: 'blob'})
            .then((response:any)=>{
                const url = window.URL.createObjectURL(new Blob([response.data],{type:fileData.fileType}));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', fileData.fileName);
                document.body.appendChild(link);
                link.click();
                link.remove()
                resolve(null)
            })
            .catch((error: any) => {
                reject(error)
            })
        })
    },
    deleteFile({commit} : {commit : any},fileId:any){
        return new Promise((resolve,reject) => {
            HTTP.delete('files/delete/'+fileId)
            .then((response:any) =>{
                commit("deleteFile",fileId)
                resolve(null)
            })
            .catch((error:any) => {
                reject(error)
            })
        })
    }
}

const fileModule = {
    namespaced:true,
    state,
    mutations,
    getters,
    actions
  }
  
  export default fileModule;